<div id="content-section">
    <div id="content-main" class="responsive-content-main" [ngStyle]="{ 'margin-right': sidebarMaximized ? '370px' : '270px' }">
        <div id="content-sidebar" [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '350px' : '250px' }" style="position: fixed; right: 20px">
            <div class="sticky-top">
                <small class="bg-white">
                  <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
                    <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
                  </a>
                </small>
            </div>
            <a href="#" (click)="goToNewDeposit($event)" class="btn btn-primary btn-sm" style="width: 100%">
              <i class="fas fa-plus-circle"></i>
              &nbsp;Add New Deposit
            </a>
            <hr class="my-1" />
            <div class="clearfix"></div>
            <div class="text-center pagination-small-margin pagination-center">
                <pagination
                (pageChanged)="search($event, null)"
                class="pagination-sm"
                [boundaryLinks]="true"
                [totalItems]="count"
                [maxSize]="5"
                [itemsPerPage]="searchParams.per_page"
                [(ngModel)]="searchParams.page"
                previousText="&lsaquo;"
                nextText="&rsaquo;"
                firstText="&laquo;"
                lastText="&raquo;"
                ></pagination>
            </div>
            <div class="text-center pt-1">
                <app-pagination-count
                    [count]="count"
                    singularName="Deposit"
                    pluralName="Deposits"
                ></app-pagination-count>
            </div>
            <hr class="my-1" />
            <div class="clearfix"></div>
            <div class="sticky-top bg-white">
                <h5 class="pt-2">
                <div class="pull-right float-right">
                    <app-clear-search-btn [searching]="searching" (onClick)="clearSearch()"></app-clear-search-btn>
                </div>
                <span>
                    Search&nbsp;&nbsp;
                    <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? (searchParams.page = 1) && search(null, true) : ''">
                        <i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i>
                    </a>
                </span>
                </h5>
                <hr class="my-1" />
            </div>
            <div class="row">
                <div class="col-md-12">
                    <form>
                        <div class="form-group">
                            <label for="status">Status:</label>
                            <select class="form-control" id="status" [(ngModel)]="searchParams['search[status]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]=""></option>
                                <option [value]="status.id" *ngFor="let status of searchOptions.statuses">{{status.name}}</option>
                            </select>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="from-date">Date From:</label>
                                <input type="text" class="form-control" #FilterFromDate="ngModel" name="from-date" [(ngModel)]="searchParams['search[date_from]']" placeholder="Click to select date" [appDatepicker]="" (dateSelected)="searchParams['search[date_from]'] = $event" id="fromDate" />
                            </div>
                            <div class="form-group col-md-6">
                                <label for="to-date">Date To:</label>
                                <input type="text" class="form-control" #FilterToDate="ngModel" name="to-date" [(ngModel)]="searchParams['search[date_to]']" placeholder="Click to select date" [appDatepicker]="" (dateSelected)="searchParams['search[date_to]'] = $event" id="toDate" />
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="bank-account">Bank Account:</label>
                            <select class="form-control" id="bank-account" [(ngModel)]="searchParams['search[bank_account_id]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]=""></option>
                                <option [value]="bank_account.id" *ngFor="let bank_account of searchOptions.bank_accounts">{{bank_account.name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="entry-group">Deposit ID:</label>
                            <input class="form-control" type="number" id="deposit-id" name="deposit-id" [(ngModel)]="searchParams.deposit_id" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-group">
                            <label for="amount">Amount:</label>
                            <input class="form-control" type="text" id="amount" name="amount" [(ngModel)]="searchParams['search[amount]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-group">
                            <label for="entry-group">Entry Group:</label>
                            <input class="form-control" type="number" id="entry-group" name="entry-group" [(ngModel)]="searchParams.entry_group_ids" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-group">
                            <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'all'">
                                <input [checked]="searchParams.reversal == 'all'" type="checkbox" name="type" class="custom-control-input" />
                                <label class="custom-control-label">All</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'hide_reversed'">
                                <input [checked]="searchParams.reversal == 'hide_reversed'" type="checkbox" name="type" class="custom-control-input" />
                                <label class="custom-control-label">Hide Reversed</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'only_reversed'">
                                <input [checked]="searchParams.reversal == 'only_reversed'" type="checkbox" name="type" class="custom-control-input" />
                                <label class="custom-control-label">Only Reversed</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <app-search-btn [searching]="searching" (onClick)="searchParams.page = 1; search(null, true)"></app-search-btn>
                        </div>
                        <div class="form-group">
                            <a class="btn btn-primary btn-sm" style="width: 100%" type="button" target='_blank' [href]="'/' + downloadCsvUrl" (click)="downloadCsv()">
                                Download CSV
                            </a>
                        </div>
                    </form>
                    <div class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                        <table class="table" style="transform: rotateX(180deg);">
                            <thead>
                                <tr>
                                    <th colspan="2">Bank Account Balances</th>
                                </tr>
                            </thead>
                            <tbody>
                               <tr *ngFor="let bank_account_balance of bank_account_balances">
                                    <th><a href='#' (click)='showBankAccount(bank_account_balance.details.bank_account.id);$event.preventDefault();'>{{bank_account_balance.name}}</a></th>
                                    <td class="text-right">
                                        <span *ngIf="bank_account_balance.details.balance">{{bank_account_balance.details.balance | currency: 'USD':'symbol':'1.2-2'}}</span>
                                        <span *ngIf="!bank_account_balance.details.balance"></span>
                                    </td>
                               </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div id="content-inner" class="responsive-content-inner" style="padding: 0px 20px 10px 20px">
            <div class="container-shadow px-3 pb-4">
                <h2 class="pt-4 text-center">Deposits</h2>
                <hr class="mt-1 mb-2" />
                <div class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                    <table class="table table-striped" style="transform: rotateX(180deg);">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Group</th>
                                <th>Receipts</th>
                                <th class='text-center'>Status</th>
                                <th>Bank</th>
                                <th>Date</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let deposit of deposits">
                                <tr>
                                    <td><a [ngClass]="{'lightblue': deposit.color_conditions.light_colored}" [href]="'/deposits/' + deposit.id">{{deposit.id}}</a></td>
                                    <td><a [ngClass]="{'lightblue': deposit.color_conditions.light_colored}" [href]="'/entry_groups/' + deposit.entry_group_id">{{deposit.entry_group_id}}</a></td>
                                    <td>
                                        <button
                                            class="btn btn-link btn-sm"
                                            type="button"
                                            *ngIf="deposit.receipts.length"
                                            (click)="deposit.showReceipts = !deposit.showReceipts">
                                            <i class="fas" [ngClass]="{'fa-plus-circle': !deposit.showReceipts, 'fa-minus-circle': deposit.showReceipts}"></i>
                                        </button>
                                        <span [ngClass]="{'lightgray': deposit.color_conditions.light_colored}">{{deposit.receipts.length}}</span>
                                    </td>
                                    <td class='text-center' [ngClass]="{'lightgray': deposit.color_conditions.light_colored}">{{deposit.status}}</td>
                                    <td><a [ngClass]="{'lightblue': deposit.color_conditions.light_colored}" [href]="'/bank_accounts/' + deposit.bank_account_id">{{deposit.bank_account.name}}</a></td>
                                    <td [ngClass]="{'lightgray': deposit.color_conditions.light_colored}">{{deposit.date}}</td>
                                    <td [ngClass]="{'lightgray': deposit.color_conditions.light_colored && !deposit.negative_amount}" [ngClass]="{'lightsalmon': deposit.color_conditions.light_colored && deposit.negative_amount}" class="text-right">
                                        <span *ngIf="deposit.amount">{{deposit.amount | currency: 'USD':'symbol':'1.2-2'}}</span>
                                        <span *ngIf="!deposit.amount"></span>
                                    </td>
                                </tr>
                                <tr *ngIf="deposit.showReceipts">
                                    <td colspan="7" class="bg-white">
                                        <div *ngIf="deposit.receipts.length" class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                                            <table class="table" style="transform: rotateX(180deg);">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th></th>
                                                        <th>Group</th>
                                                        <th>Bank</th>
                                                        <th>From</th>
                                                        <th>Date</th>
                                                        <th class="text-center">Document</th>
                                                        <th class="text-right">Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let receipt of deposit.receipts">
                                                        <td><a [href]="'/receipts/' + receipt.id">{{receipt.id}}</a></td>
                                                        <td><a [href]="receipt.tree_link_path"><i class="fas fa-tree"></i></a></td>
                                                        <td><a [href]="'/entry_groups/' + receipt.entry_group_id">{{receipt.entry_group_id}}</a></td>
                                                        <td><a [href]="'/bank_accounts/' + receipt.bank_account_id">{{receipt.bank_account.name}}</a></td>
                                                        <td>
                                                            <a [href]="'/companies/' + receipt.contact.id" *ngIf="receipt.contact.company_name">{{receipt.contact.display_name}}</a>
                                                            <a [href]="'/persons/' + receipt.contact.id" *ngIf="!receipt.contact.company_name">{{receipt.contact.display_name}}</a>
                                                        </td>
                                                        <td>{{receipt.date}}</td>
                                                        <td class="text-center" [innerHTML]="receipt.document | safeHtml"></td>
                                                        <td class="text-right">
                                                            <span *ngIf="receipt.amount">{{receipt.amount | currency: 'USD':'symbol':'1.2-2'}}</span>
                                                            <span *ngIf="!receipt.amount"></span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="7" class="text-right">Total Receipts for this page are:</td>
                                                        <td class="text-right">
                                                            <span *ngIf="deposit.receipts_total">{{deposit.receipts_total | currency: 'USD':'symbol':'1.2-2'}}</span>
                                                            <span *ngIf="!deposit.receipts_total"></span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <h3 style="transform: rotateX(180deg);">Receipts for Deposit <a [href]="'/deposits/' + deposit.id">#{{deposit.id}}</a></h3>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<app-sidebar-toggle-btn [sidebarOpen]="sidebarOpen" (onClick)="sidebarOpen = !sidebarOpen"></app-sidebar-toggle-btn>